var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
/* tslint:disable: cyclomatic-complexity */
/* tslint:disable: no-non-null-assertion */
import * as React from "react";
import * as CMP from "../../components";
import { DictContextConsumer } from "../../dict";
import { Icon, Loader } from "sb-resp-ui";
import { observer } from "mobx-react";
import { observe } from "mobx";
let JackpotItem = class JackpotItem extends React.Component {
    constructor(props) {
        super(props);
        let jp = this.props.jackpot;
        this.toLoadImgs = [jp.image, jp.animationBottomLeft, jp.animationTopRight].filter(x => !!x).map(x => x.src);
        this.state = {
            isLoadingImgs: true
        };
        observe(jp.updatingData, "IsWithoutRealUpdates", change => {
            //we should observe with 'fireImmediately' for popup but skip 'undefined' value on render as superbanner item
            if (typeof change.newValue !== "boolean") {
                return;
            }
            let loadAssets = !change.newValue || this.props.usedAsPartOfBlock;
            loadAssets && this.lazyLoadAssetsOnRealUpdate();
        }, true);
    }
    lazyLoadAssetsOnRealUpdate() {
        if (!this.toLoadImgs.length) {
            this.setState({ isLoadingImgs: false });
        }
        let waitLoad = this.toLoadImgs.map(x => {
            return new Promise((resolve, reject) => {
                let img = document.createElement("img");
                img.onload = resolve;
                img.onerror = resolve;
                img.src = x;
            });
        });
        Promise.all(waitLoad).then(_ => {
            this.setState({ isLoadingImgs: false });
        }).catch(err => { });
    }
    render() {
        let jackpot = this.props.jackpot, toShowInfoIcon = jackpot.IsCountdownType && !jackpot.updatingData.IsWon;
        if (this.state.isLoadingImgs) {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "rj-superbanner__loader" },
                    React.createElement(Loader, null)));
        }
        return (React.createElement(React.Fragment, null,
            jackpot.image &&
                React.createElement("div", { style: { backgroundImage: `url('${jackpot.image.src}')` }, className: "rj-jackpot__item-background" }),
            jackpot.animationTopRight &&
                React.createElement("div", { className: "rj-jackpot__item-decorator rj-jackpot__item-decorator--right", style: { backgroundImage: `url('${jackpot.animationTopRight.src}')` } }),
            jackpot.animationBottomLeft &&
                React.createElement("div", { className: "rj-jackpot__item-decorator rj-jackpot__item-decorator--left", style: { backgroundImage: `url('${jackpot.animationBottomLeft.src}')` } }),
            toShowInfoIcon &&
                React.createElement(Icon, { i: "icon i-o-info i-18" }),
            React.createElement("div", { className: "rj-jackpot__item-header" },
                React.createElement("div", { className: "rj-jackpot__item-title" }, jackpot.Name),
                jackpot.updatingData.currencyId && (React.createElement("div", { className: "rj-jackpot__item-ticker" },
                    React.createElement(CMP.TickerDiv, { jackpot: jackpot.updatingData, tickerConfig: this.props.tickerConfig }))),
                React.createElement(DictContextConsumer, null, dict => React.createElement(CMP.DatePart, { jackpot: jackpot, dict: dict, datePartConfig: this.props.datePartConfig })))));
    }
};
JackpotItem = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], JackpotItem);
export { JackpotItem };
//# sourceMappingURL=JackpotItem.js.map